import { render, staticRenderFns } from "./Launch.vue?vue&type=template&id=1989eaf2&"
import script from "./Launch.vue?vue&type=script&lang=js&"
export * from "./Launch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports